import { render, staticRenderFns } from "./FlipbookWithUI.vue?vue&type=template&id=3a0c4fb2&"
import script from "./FlipbookWithUI.vue?vue&type=script&lang=js&"
export * from "./FlipbookWithUI.vue?vue&type=script&lang=js&"
import style0 from "./FlipbookWithUI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports